import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { useSelector } from 'react-redux';
import NativePage from './404.old';
import RevampPage from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page-revamp';
import { ChannelType, WebSiteSubType } from 'src/types/common/SalesChannel';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import React from 'react';

const AllProductsJunction = (props) => {
  const type = useSalesChannelType();
  const isMini = type === ChannelType.MiniProgram;
  const isNative =
    useSelector(currentSelectedStyle()) === WebSiteSubType.NativeMobile;
  return isMini || isNative ? (
    <NativePage {...props} />
  ) : (
    <RevampPage {...props} />
  );
};
export default AllProductsJunction;
